import React, { useState } from 'react'
import { login } from './service/studyService'

export default function StudyLogin ({ config, onLogin }) {
  const [id, setId] = useState('')
  const [err, setErr] = useState('')

  const submit = async (candidate) => {
    const value = (candidate || id).trim()
    if (!value) return
    setErr('')
    try {
      const p = await login(value)
      onLogin(p.participantId)
    } catch (e) {
      setErr(e.response?.data?.error || e.message)
    }
  }

  return (
    <div className="study-root study-login">
      <div className="study-card">
        <h1 className="study-h1">VizPI Study</h1>
        <p>Enter your participant ID to begin.</p>
        <div className="study-actions">
          <input className="study-input" value={id} onChange={e => setId(e.target.value)}
            placeholder="Participant ID" onKeyDown={e => e.key === 'Enter' && submit()} />
          <button className="study-btn study-btn--primary" onClick={() => submit()}>Enter</button>
        </div>
        {err && <p className="study-err">{err}</p>}
        {config?.testMode && (
          <div className="study-testlogins">
            <div className="study-testlogins__title">TEST MODE — quick logins</div>
            <div className="study-testlogins__row">
              {config.testParticipants.map(t => (
                <button key={t} className="study-btn study-btn--ghost" onClick={() => submit(t)}>{t}</button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
